import { dateTime } from "@gravity-ui/date-utils";
import { GameLevel, GameStatus, GameUserRole, GameUserStatus, RequestMode, } from "@/store/api";
/** Формат: 1 января 2025 */
var formatDate = function (dateString) {
    return dateTime({ input: dateString }).format("LL");
};
/** День недели для даты: понедельник */
var weekdayDate = function (dateString) {
    return dateTime({ input: dateString }).format("dddd");
};
/** Статус участия в игре */
var getMemberStatusLabel = function (status) {
    switch (status) {
        case GameUserStatus.Invited:
            return { text: "Приглашен", theme: "info" };
        case GameUserStatus.Requested:
            return { text: "Запрос", theme: "warning" };
        case GameUserStatus.Allowed:
            return { text: "Одобрен", theme: "success" };
        case GameUserStatus.Declined:
            return { text: "Отклонен", theme: "danger" };
        case GameUserStatus.Confirmed:
            return { text: "Подтвержден", theme: "normal" };
        default:
            return { text: status, theme: "unknown" };
    }
};
/** Статус игры */
var getGameStatusLabel = function (status) {
    switch (status) {
        case GameStatus.Draft:
            return { text: "Черновик", theme: "warning" };
        case GameStatus.Aproved:
            return { text: "Подтверждена", theme: "success" };
        default:
            return { text: status, theme: "unknown" };
    }
};
/** Статус юзера */
var getRoleLabel = function (role) {
    switch (role) {
        case GameUserRole.Creator:
            return { text: "Создатель", theme: "clear" };
        case GameUserRole.Member:
            return { text: "Участник", theme: "clear" };
        default:
            return { text: role, theme: "unknown" };
    }
};
/** Уровень сложности игры */
var getGameLevelLabel = function (level) {
    switch (level) {
        case GameLevel.Easy:
            return { text: "Простой", theme: "success" };
        case GameLevel.Medium:
            return { text: "Средний", theme: "warning" };
        case GameLevel.Hard:
            return { text: "Сложный", theme: "danger" };
        default:
            return { text: level, theme: "unknown" };
    }
};
/** Режим набора участников */
var getRequestModeLabel = function (mode) {
    switch (mode) {
        case RequestMode.Private:
            return { text: "Приватная игра", theme: "info" };
        case RequestMode.Moderate:
            return { text: "По запросу", theme: "warning" };
        case RequestMode.Public:
            return { text: "Открыто для всех", theme: "success" };
        default:
            return { text: mode, theme: "unknown" };
    }
};
export { formatDate, weekdayDate, getGameStatusLabel, getRoleLabel, getMemberStatusLabel, getGameLevelLabel, getRequestModeLabel, };
